module.exports = __webpack_public_path__ + "img/dz.300c3990.svg";